<template>
  <div ref="elRef" class="flex">
    <div class="flex flex-col items-center mt-1 mr-2">
      <div class="rounded-full border border-[#E2E5ED]" style="width: 11px; height: 11px"></div>
      <div style="width: 1px" class="flex-grow bg-[#E2E5ED]"></div>
    </div>
    <div class="flex flex-col items-start">
      <a
        :href="article.breadcrumb[0].route"
        class="text-sm font-bold leading-18 py-0.5 px-2 text-white rounded-sm mb-2"
        :style="{ backgroundColor: getCategoryColor(article.breadcrumb[0].route) }"
      >
        {{ article.breadcrumb[0].name }}
      </a>
      <a
        class="line-clamp-2 font-semibold text-md hover:text-link-primary text-primary-100"
        :href="getArticleUrl({ article })"
        @click="
          clickEvent();
          handleClickArticle();
        "
      >
        {{ article.title }}
      </a>
    </div>
  </div>
</template>
<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { getCategoryInfoByPath } from '@/modules/category/utils/categoryHelpers';
import { useTracking } from '@/modules/tracking/composables/useTracking';
import { getArticleUrl } from '~/modules/common/utils/routingUtils';
import { onedioEvents } from '~/modules/tracking/scripts/onedioEvents';

export default defineComponent({
  props: {
    article: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const { sendDetayInteractionEvent } = onedioEvents();
    const getCategoryColor = (path) => getCategoryInfoByPath(path)?.color;

    // Data Layer Impression & Click
    const { sendDataLayer } = useTracking();
    const { elRef, clickEvent } = sendDataLayer(
      {
        item: props.article,
        list: 'Haber Detay - En Yeni İçerikler',
        position: parseInt(props.index),
      },
      ['scroll', 'click']
    );

    const handleClickArticle = () => {
      sendDetayInteractionEvent('Ara kartlar', 'Click', 'En Yeni İçerikler');
    };

    return {
      getCategoryColor,
      getArticleUrl,
      elRef,
      clickEvent,
      handleClickArticle,
    };
  },
});
</script>
